import React, { useEffect, useState } from "react";
import {
  PatternlibOverlayContainer,
  PatternlibAvatar,
  PatternlibIcon,
  PatternlibFlyoutmenuSeparator,
  PatternlibFlyoutmenuItem,
} from "@liebherr/patternlib-react";
import styles from "./AuthStatus.module.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";

const AuthStatus = ({ profile, isDemoUser }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const [userInitial, setUserInitial] = useState();

  useEffect(() => {
    if (profile) {
      let firstName = "";
      let lastName = "";
      const givenName = profile["given_name"];
      const familyName = profile["family_name"];

      if (givenName !== null && familyName !== null) {
        firstName = givenName;
        lastName = familyName;
      }

      setUser(firstName + " " + lastName);
      setUserInitial(firstName.charAt(0) + lastName.charAt(0));
    } else {
      setUser(null);
      setUserInitial(null);
    }
  }, [profile]);

  const logout = () => {
    auth.removeUser();
    navigate("/");
  };

  if (!user && !userInitial) {
    return null;
  }

  return (
    <PatternlibOverlayContainer target="element" show-arrow>
      <PatternlibAvatar
        initials={userInitial}
        slot="element"
      ></PatternlibAvatar>
      <div slot="content" className={styles.content}>
        <div className={styles.userWrapper}>
          <PatternlibAvatar
            initials={userInitial}
            no-states
            slot="element"
          ></PatternlibAvatar>
          <span className={styles.user}>{user}</span>
        </div>
        {!isDemoUser && (
          <>
            <PatternlibFlyoutmenuSeparator></PatternlibFlyoutmenuSeparator>
            <PatternlibFlyoutmenuItem label={t("logOut")} onClick={logout}>
              <PatternlibIcon
                icon-name="x"
                slot="icon-left"
                bold
              ></PatternlibIcon>
            </PatternlibFlyoutmenuItem>
          </>
        )}
      </div>
    </PatternlibOverlayContainer>
  );
};

export default AuthStatus;
